import { IUser, ICenter, ICenterMetrics } from "../../models/index";
import { DisplayType, OrganType } from "../../enums/index";

export interface IPortalOpo {
    id: number,
    name: string,
    alias: string
}

export interface IAppState {
    loading: boolean,
    loadingMessage?: string,
    error?: string,
    menuVisible?: boolean,
    user?: IUser,
    alert: {
        show: boolean,
        title: string,
        message: string | JSX.Element
    },
    display: DisplayType,
    center: ICenter,
    centerMetrics: ICenterMetrics,
    opo: IPortalOpo | null,
    site: {
        domain: string,
        organ: string,
        organType: OrganType
    }
}

export const unloadedState: IAppState = {
    loading: false,
    loadingMessage: "One moment please...",
    error: undefined,
    menuVisible: false,
    alert: {
        show: false,
        title: "",
        message: ""
    },
    display: DisplayType.All,
    center: null,
    centerMetrics: null,
    opo: null,
    site: {
        domain: '',
        organ: '',
        organType: null
    }
};